import router from '@/router/index';
import store from '@/store';
import axios from 'axios';

// const whiteList: any[] = ['home', 'schedule', 'login', 'competitions']; // 路由白名单
const configList = ['login', 'register', 'forget', 'activity', 'specials','users',  'users-profile'];
const LoginList = ['users', 'activity', 'activity-self-invite', 'activity-rank', 'activity-share-poster', 'activity-shipping-address']; // 必须登录

router.beforeEach(async (to, from, next) => {
    // const _hmt = (window as any)._hmt
    // // 百度统计受访页面
    // _hmt && _hmt.push(['_trackPageview', to.fullPath]);
    if(!/\/special\/./.test(to.fullPath)){
        document.title = '加入DF，成为数据科学家！DataFountain'
    }

    // 记录访问页
    visitedLog(to)

    // 活动邀请逻辑
    // 判断是否为活动邀请来的用户，是则将邀请信息缓存至 localStorage
    if (to.query.target && to.query.special) {
        localStorage.setItem("activity-invite-info", JSON.stringify({ ...to.query, date: new Date().getTime() }));
    }
    // 超过24小时则删除邀请人的记录，再次报名将作为自然报名
    const wapInviteInfo = JSON.parse(localStorage.getItem('activity-invite-info') as any) || {};
    if(wapInviteInfo && new Date(wapInviteInfo.time).getTime() < (new Date().getTime() - 86400000)){
        localStorage.removeItem('activity-invite-info');
    }

    const whiteList = [/\/404/i, /\/error/i, /\/activity\/[^/]+\/share-poster/i]
    const pass = whiteList.some((item) => {
        return item.test(to.path);
    })

    if (pass) {
        return next();
    }
    //白名单过滤
    if (process.env.NODE_ENV === 'development') {
        try {
            const res: any = await axios({
                method: 'get',
                url: `/api/config/v1/sso?path=${to.path}`,
            });
            const {
                data: { key, sign, publicKey, exponent, user, ssoUserId, csrf, _csrf, tongjiUrl, fp },
            } = res.data;
            store.dispatch('initEnctype', { key, sign, publicKey, exponent, user, ssoUserId, csrf, _csrf, tongjiUrl, fp });
            const userInfo = JSON.parse(user) || null;
            // visitedLog(to)
            if (LoginList.includes(<string>to.name)) {
                if (userInfo && userInfo.name) {
                    next();
                } else {
                    next('/login?source=' + from.fullPath);
                }
                return false;
            } else {
                next();
            }
            next();
        } catch (e) {
            // 获取不到用户信息，且报错时
            if (LoginList.includes(<string>to.name)) {
                next('/login?source=' + from.fullPath);
                return false;
            } else {
                next();
            }
        }
    } else {
        if (configList.includes(<string>to.name)) {
            const res: any = await axios({
                method: 'get',
                url: `/api/config/v1/sso?path=${to.path}`,
            });
            const {
                data: { key, sign, publicKey, exponent, user, ssoUserId, csrf, tongjiUrl, fp },
            } = res.data;
            store.dispatch('initEnctype', { key, sign, publicKey, exponent, user, ssoUserId, csrf, tongjiUrl, fp });
        }
        // visitedLog(to)
        if (LoginList.includes(<string>to.name)) {
            // 其它开发环境处理方式
            if (JSON.stringify(store.state.userInfo) !== '{}') {
                next();
            } else {
                next('/login?source=' + from.fullPath);
                // 跳转登录页
                return false;
            }
            next();
        } else {
            next();
        }
    }
});

async function visitedLog(to) {
    const {data: {data}} = await axios({
        method: 'get',
        url: `/api/config/v1/fp?path=${to.path}`,
    });

    const cc = new Image();
    cc.style.display = 'none'
    const user : any = store.state.userInfo
    let tongjiUrl
    if(location.hostname.indexOf('local') > -1 || location.hostname.indexOf('dev') > -1){
        tongjiUrl = 'http://dev-api-tongji.datafountain.cn'
    }else{
        tongjiUrl = 'http://api-tongji.datafountain.cn'
    }
    
    cc.src = `${tongjiUrl}/api/visited?hostname=${location.hostname}&path=${to.path}&fullPath=${to.fullPath}&userId=${user ? user.id : ""}&ssoId=${user ? user.userId : ""}&fp=${data.fp}`;
    document.querySelectorAll('body')[0].appendChild(cc);
}